const getDeliveryDayEstimates = (currentDay, isBeforeCutoff) => {
  switch (currentDay) {
    case "Monday":
      if (isBeforeCutoff) {
        return {normal: Localizations.relativeDays.tomorrow, special: Localizations.relativeDays.tonight, flavour: Localizations.relativeDays.today};
      } else {
        return {
          normal: Localizations.words.on + " " + Localizations.days.wednesday,
          special: Localizations.relativeDays.tomorrow,
          flavour: Localizations.relativeDays.tomorrow
        };
      }
    case "Tuesday":
      if (isBeforeCutoff) {
        return {normal: Localizations.relativeDays.tomorrow, special: Localizations.relativeDays.tonight, flavour: Localizations.relativeDays.today};
      } else {
        return {
          normal: Localizations.words.on + " " + Localizations.days.thursday,
          special: Localizations.relativeDays.tomorrow,
          flavour: Localizations.relativeDays.tomorrow
        };
      }
    case "Wednesday":
      if (isBeforeCutoff) {
        return {normal: Localizations.relativeDays.tomorrow, special: Localizations.relativeDays.tonight, flavour: Localizations.relativeDays.today};
      } else {
        return {
          normal: Localizations.words.on + " " + Localizations.days.friday,
          special: Localizations.relativeDays.tomorrow,
          flavour: Localizations.relativeDays.tomorrow
        };
      }
    case "Thursday":
      if (isBeforeCutoff) {
        return {normal: Localizations.relativeDays.tomorrow, special: Localizations.relativeDays.tonight, flavour: Localizations.relativeDays.today};
      } else {
        return {
          normal: Localizations.words.on + " " + Localizations.days.monday,
          special: Localizations.relativeDays.tomorrow,
          flavour: Localizations.relativeDays.tomorrow
        };
      }
    case "Friday":
      if (isBeforeCutoff) {
        return {
          normal: Localizations.words.on + " " + Localizations.days.monday,
          special: Localizations.relativeDays.tonight,
          flavour: Localizations.relativeDays.today
        };
      } else {
        return {
          normal: Localizations.words.on + " " + Localizations.days.tuesday,
          special: Localizations.words.on + " " + Localizations.days.monday,
          flavour: Localizations.words.on + " " + Localizations.days.monday
        };
      }
    case "Saturday":
      return {
        normal: Localizations.words.on + " " + Localizations.days.tuesday,
        special: Localizations.words.on + " " + Localizations.days.monday,
        flavour: Localizations.words.on + " " + Localizations.days.monday
      };
    case "Sunday":
      return {
        normal: Localizations.words.on + " " + Localizations.days.tuesday,
        special: Localizations.words.on + " " + Localizations.days.monday,
        flavour: Localizations.words.on + " " + Localizations.days.monday
      };
    default:
      return {
        normal: Localizations.words.on + " " + Localizations.days.tuesday,
        special: Localizations.words.on + " " + Localizations.days.monday,
        flavour: Localizations.words.on + " " + Localizations.days.monday
      };
  }
};

const getIsBeforeCutoff = (currentHour, currentMinutes) => {
  let cutoffHour = Number('14');
  let cutoffMinutes = Number('55');

  cutoffHour = Number.isNaN(cutoffHour)
    ? 14
    : cutoffHour;
  cutoffMinutes = Number.isNaN(cutoffMinutes)
    ? 55
    : cutoffMinutes;

  if (currentHour < cutoffHour) {
    return true;
  } else if (currentHour == cutoffHour && currentMinutes <= cutoffMinutes) {
    return true;
  } else {
    return false;
  }
}

const showLinkToDeliveryEstimate = () => {
  const elements = document.querySelectorAll("#delivery-estimate-favour-link");

  for (const element of elements) {
    element.classList.remove('hidden')
  }
}

const updateDeliveryEstimate = () => {
  const currentTime = new Date();

  const currentDay = currentTime.toLocaleString("EN", {weekday: "long"});
  const currentHour = currentTime.getHours();
  const currentMinutes = currentTime.getMinutes();

  const isBeforeCutoff = getIsBeforeCutoff(currentHour, currentMinutes);

  const isWeekend = (currentDay === "Friday" && isBeforeCutoff == false) || currentDay === "Saturday" || currentDay === "Sunday"
    ? true
    : false;

  const deliveryEstimates = getDeliveryDayEstimates(currentDay, isBeforeCutoff);

  const flavourDeliveryElementList = document.querySelectorAll("#delivery-estimate-flavour-field");
  const normalDeliveryElementList = document.querySelectorAll("#delivery-estimate-normal-field");
  const specialDeliveryElementList = document.querySelectorAll("#delivery-estimate-special-field");


  if (normalDeliveryElementList.length > 0) {
    showLinkToDeliveryEstimate();
  }

  for (const element of flavourDeliveryElementList) {
    element.innerText = deliveryEstimates.flavour
  }

  for (const element of normalDeliveryElementList) {
    let normalText = deliveryEstimates.normal;

    if (currentDay === "Friday" && isBeforeCutoff && element.closest(".delivery-estimate-info").classList.contains('parcel')) {
      normalText = Localizations.relativeDays.tomorrow;
    }

    element.innerText = normalText;
  }

  for (const element of specialDeliveryElementList) {
    element.innerText = deliveryEstimates.special;
  }

  if (! isBeforeCutoff || isWeekend) {
    const orderBeforeElementList = document.querySelectorAll("#delivery-estimate-order-before");

    for (const element of orderBeforeElementList) {

      const deliveryElement = document.createElement('div');

      const deliveryType = document.createElement("span");
      const orderBeforeText = document.createElement("span");
      const deliveryCutoff = document.createElement("span");
      deliveryCutoff.id = "delivery-cutoff";

      deliveryType.innerHTML = element.firstElementChild.innerText;

      if (isWeekend) {
        orderBeforeText.innerText = Localizations.phrases.orderBy + " " + Localizations.days.sunday;
      } else {
        orderBeforeText.innerText = Localizations.words.order + " " + Localizations.relativeDays.today;
      };

      deliveryElement.classList = element.classList;

      deliveryElement.appendChild(deliveryType);
      deliveryElement.appendChild(orderBeforeText);
      deliveryElement.appendChild(deliveryCutoff);

      element.replaceWith(deliveryElement);
    }
  }
};